export enum ESmartDateSelectionRangeType {
    CurrentWeek = 'This week',
    CurrentMonth = 'This month',
    CurrentQuarter = 'This quarter',
    CurrentFinancialYear = 'This financial year',
    LastWeek = 'Last week',
    LastMonth = 'Last month',
    LastQuarter = 'Last quarter',
    LastFinancialYear = 'Last financial year',
    MonthToDate = 'Month to date',
    QuarterToDate = 'Quarter to date',
    YearToDate = 'Year to date',
}

export enum DateFormat {
    yyyyMMdd = 'yyyy-MM-dd',
}
